module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 606
// module chunks = 0